export default "__VITE_ASSET__Cc1fUuK3__"